import Vue from 'vue';
import Vuex from 'vuex';
import vuejsStorage from 'vuejs-storage';
import Data from '../plugins/data.js'
import { AppTextStatic } from '../plugins/appTextStatic.js';

Vue.use(Vuex)
Vue.use(vuejsStorage)

export const store = new Vuex.Store({
    state: {
        accessToken : false,
        bearerToken: null,
        year: new Date().getFullYear(),
        surveyID: null,
        status: 'live',
        allYears: [],
        allResources: [],
        allResourcesWelsh: [],
        type: 'primary',
        accountInfo: [],
        completed: [],
        resourceDownloads: [],
        watchedVideos: [],
        isFullscreen: false,
        surveyCompletedGeneral: null,
        surveyCompletedLive: null,
        videoPath: [],
        // Old
        resourceData: [],
        videoData: [],
        lastVideoID: [],
        language: null,
        appTextLanguage: new AppTextStatic()
        
    },
    getters : {
        getAppText: (state) => {
            return state.appText;
        },
        getAppTextLanguage: (state) => {
            console.log(state.appTextLanguage);
            return state.appTextLanguage;
        },
        getAppTextEn: (state) => {
            return state.appTextEn;
        },
        getAppTextCy: (state) => {
            return state.appTextCy;
        },
        getLanguage: (state) => {

        if(state.language != null)
        {
            return state.language;
        }
        const urlParams = new URLSearchParams(window.location.search);
        const language = urlParams.get("language");
    
        if(language == "cy")
        {
            return language;
        }
    
        return "en"; // default
        },
        // expects array of resource ids
        getResourcesByIds: (state) => (resourceIds) => {
          let resources = [];
            resourceIds.map(function(value,key){
                resources.push(state.resourceData[value]);
            });
          return resources;
        },
        getVideoById: (state) => (videoId) => {
            return state.videoData.questions[videoId];
        },
        hasAccessToken: state =>{
            return state.bearerToken;
        },
        // accessTokenValid: state =>{
        //     // Grab from storage
        //     Vue.http.post(process.env.WP_ENDPOINT + 'jwt-auth/v1/token/validate', {}, {
        //         headers: {
        //             'Authorization': 'Bearer ' + store.getters.getBearerToken
        //         },
        //         timeout: 60000
        //     }).then(function (response) {
        //         if (response.data != null && response.data != '' && response.data.data.status == "200") {
        //             // Valid, keep logged in.
        //             return true;
        //         } 
        //         else if (response.data != null && response.data != '' && response.data.data.status == "403") {
        //             // Remve and require reaccess
        //             window.localStorage.removeItem('ye-interactive-videos');
        //             state = {};
        //             return false;
        //         }
        //     }, function (response) {
        //         // Error
        //         window.localStorage.removeItem('ye-interactive-videos');
        //         state = {};
        //         store.dispatch('genericError', 'Apologies, something appears to have gone wrong and you have been logged out.', 10000);
        //         return false;
        //     });
        // },
        getResourceDownloads: state => {
          return state.resourceDownloads;
        },
        getCompleted: state => (year, type) => {
            if(typeof state.completed['year_' + year] === 'undefined'){ 
                return false;
            } else if (typeof state.completed['year_' + year][type] === 'undefined') {
                return false;
            }
            return state.completed['year_' + year][type];
        },
        getFullscreen: state => {
            if(!state.isFullscreen){
                state.isFullscreen = false;
            }
            return state.isFullscreen;
        },
        getlastVideoID: state => (year, type) => {
            if(typeof state.lastVideoID['year_' + year] === 'undefined'){ 
                return 0;
            } else if (typeof state.lastVideoID['year_' + year][type] === 'undefined') {
                return 0;
            }

          return state.lastVideoID['year_' + year][type];
        },
        getVideoPath: state => (year, type) => {
            if(typeof state.videoPath['year_' + year] === 'undefined'){ 
                return [1];
            } else if (typeof state.videoPath['year_' + year][type] === 'undefined') {
                return [1];
            }
            return state.videoPath['year_' + year][type];
        },
        getAppVersion: state => {
            return process.env.DATA;
        },
        getVideoData: state => {
            return state.videoData;
        },
        getYear: state => {
            return state.year;
        },
        getStatus: state => {
            return state.status;
        },
        getSurveyGeneralID: state => {
            return state.surveyGeneralID;
        },
        getSurveyLiveID: state => {
            return state.surveyLiveID;
        },
        getYears: state => {
            return state.allYears;
        },
        getAllResources: state => {
            return state.allResources;
        },
        getAllResourcesWelsh: state => {
            return state.allResourcesWelsh;
        },
        getResourcesFor: (state) => (year, type) => {
            return state.allResources[year][type];
        },
        getResourcesForWelsh: (state) => (year, type) => {
            return state.allResourcesWelsh[year][type];
        },
        getType: state => {
            return state.type;
        },
        getBearerToken: state => {
            return state.bearerToken;
        },
        getAccountInfo: state => {
            return state.accountInfo;
        },
        getSurveyCompletedGeneral: state=> {
            return state.surveyCompletedGeneral;
        },
        getSurveyCompletedLive: state=> {
            return state.surveyCompletedLive;
        }
    },
    mutations: {
        setLanguage(state, language) {
            state.language = language;
        },
        setAppText(state, appText) {
            state.appText = appText;
        },
        setAppTextLanguage(state) {
            state.appTextLanguage = new AppTextStatic();
        },
        addResourceDownload: (state, resource) => {
            
            let found = false;
            // Create custom key
            let newkey = resource.year + '_' + resource.type + '_' + resource.index;
            resource.key = newkey;

            resource.language = state.language;

            state.resourceDownloads.map(function(existing_download,key){
                if(existing_download.key == newkey){
                    found = true;
                }
            });

            // // if this hasn't already been downloaded and logged then add
            if(!found){
                state.resourceDownloads.push(resource); 

                // Send tracking data
                store.dispatch('trackData', {
                    type: 'resource',
                    data: resource
                });
            }

        },
        addVideoWatch: (state, video) => {
            let found = false;
            let newkey = video.year + '_' + video.type + '_' + video.id;
            let newVideo = {
                year: video.year,
                type: video.type,
                id: video.id,
                index: video.id,
                filename: video.title,
                key: newkey
            };
            state.watchedVideos.map(function(existing, key) {
                if(existing == newkey) {
                    found = true;
                }
            });
            if(!found) {
                // Send to WP
                state.watchedVideos.push(newkey);
                // Send tracking data
                store.dispatch('trackData', {
                    type: 'video',
                    data: newVideo
                });
            }
        },
        videoPath: (state, video) => {
            if(typeof state.videoPath['year_'+video.year] === 'undefined'){
                var newPath = { ['year_'+video.year]:{
                    'primary': [],
                    'secondary': []
                }};
                newPath['year_'+video.year][video.type].push(1);
                newPath['year_'+video.year][video.type].push(video.id);
                var newPathM = {...state.videoPath, ...newPath};
                state.videoPath = newPathM;
            } else {
                var newPath = state.videoPath;
                newPath['year_'+video.year][video.type].push(video.id);
                state.videoPath = newPath;
            }

            // Send tracking data
            let dataTrack = {
                index: 0,
                year: video.year,
                type: video.type,
                order: newPath['year_'+video.year][video.type],
                filename: 'Video Path',
                key: null
            }
            store.dispatch('trackData', {
                type: 'video_path',
                data: dataTrack
            });

        },
        setHasAccess:(state) => {
            state.accessToken = true;
        },
        setLostAccess:(state) => {
            state.accessToken = false,
            state.bearerToken = null,
            state.surveyID = null,
            state.allYears = [],
            state.allResources = [],
            state.allResourcesWelsh = [],
            state.type = 'primary',
            state.accountInfo = [],
            state.completed = [],
            state.resourceDownloads = [],
            state.watchedVideos = [],
            state.isFullscreen = false,
            state.surveyCompletedGeneral = null,
            state.surveyCompletedLive = null,
            state.videoPath = [],
            state.resourceData = [],
            state.videoData = [],
            state.lastVideoID = []
            // setTimeout(() => {
            //     console.log(window.localStorage.removeItem('ye-interactive-videos'));
            // }, 200);
        },
        setMMWStatus:(state, data) => {
            state.year = data.year;
            state.status = data.state;
            state.surveyGeneralID = data.surveyGeneral;
            state.surveyLiveID = data.surveyLive;
        },
        setMMWType:(state, data) => {
            state.type = data;
        },
        setBearerToken:(state, data) => {
            state.bearerToken = data;
        },
        setAccountInfo:(state, data) => {
            state.accountInfo = data;
        },
        setNumberOfStudents:(state, data) => {
            state.accountInfo.number_of_students = data;
        },
        setTrackingInfo:(state, data) => {
            console.log(data);
            state.resourceDownloads = (data.resourceDownloads != null ? data.resourceDownloads : []);
            state.watchedVideos = (data.watchedVideos != null ? data.watchedVideos : []);
            state.videoPath = (data.videoPath != null ? data.videoPath : []);
            state.lastVideoID = (data.lastVideoID != null ? data.lastVideoID : []);
            state.completed = (data.completed != null ? data.completed : []);
            state.surveyCompletedGeneral = data.surveyCompletedGeneral;
            state.surveyCompletedLive = data.surveyCompletedLive;
        },
        setCompleted : (state, value) => {
            if(typeof state.completed['year_'+value.year] === 'undefined'){
                var newState = {['year_'+value.year]: {
                    'primary': false,
                    'secondary': false
                }};
                newState['year_'+value.year][value.type] = true;
                var newStateM = {...state.completed, ...newState};
                state.completed = newStateM;
            } else {
                var newState = state.completed;
                newState['year_'+value.year][value.type] = true;
                state.completed = newState;
            }

            // Send tracking data
            store.dispatch('trackData', {
                type: 'completion',
                data: value
            });
        },
        setFullscreen: (state, value) => {
            state.isFullscreen = value;
        },
        setLastVideoID: (state, value) => {
            if(typeof state.lastVideoID['year_'+value.year] === 'undefined'){
                var newState = { ['year_'+value.year]:{
                    'primary': [],
                    'secondary': []
                }};
                newState['year_'+value.year][value.type] = value.videoId;
                var newStateM = {...state.lastVideoID, ...newState};
                state.lastVideoID = newStateM;
            } else {
                var newState = state.lastVideoID;
                newState['year_'+value.year][value.type] = value.videoId;
                state.lastVideoID = newState;
            }
        },
        restartVideoData: (state, value) => {
            if(typeof state.lastVideoID['year_' + value.year] !== 'undefined' && typeof state.lastVideoID['year_' + value.year][value.type] !== 'undefined') {
                state.lastVideoID['year_' + value.year][value.type] = 0;
            }
            if(typeof state.completed['year_' + value.year] !== 'undefined' && typeof state.completed['year_' + value.year][value.type] !== 'undefined') {
                state.completed['year_' + value.year][value.type] = false;
            }
            if(typeof state.videoPath['year_' + value.year] !== 'undefined' && typeof state.videoPath['year_' + value.year][value.type] !== 'undefined') {
                state.videoPath['year_' + value.year][value.type] = [];
                state.videoPath['year_' + value.year][value.type].push(1);
            }
             // Send tracking data
             store.dispatch('trackData', {
                type: 'restart',
                data: value
            });
        },
        setVideoData: (state, value) => {
            state.videoData = value;
        },
        setYears: (state, value) => {
            state.allYears = value;
        },
        setResources: (state, value) => {
            state.allResources = value;
        },
        setResourcesWelsh: (state, value) => {
            state.allResourcesWelsh = value;
        },
        setSurveyCompletedGeneral: (state, value) => {
            state.surveyCompletedGeneral = value;
        },
        setSurveyCompletedLive: (state, value) => {
            state.surveyCompletedLive = value;
        }
    },
    actions: {
        addResourceDownload: ({commit}, resource) => {
            store.commit('addResourceDownload', resource);
        },
        addVideoWatch:({commit}, video) => {
            store.commit('addVideoWatch', video);
        },
        videoPath: ({commit}, video) => {
            store.commit('videoPath', video);
        },
        trackData:({commit}, payload) => {
            console.log(payload);
            // Send to WP
            Vue.http.post(process.env.WP_ENDPOINT + 'mmw/v1/mmw-userchoice', payload, {
                headers: {
                    'Authorization': 'Bearer ' + store.getters.getBearerToken
                },
                timeout: 60000,
                hidden: true
            }).then(function (response) {
                console.log(response.data);
                if(response.data.code == 200) {
                }
            },function (response) {
                // Error
                console.log(response.data);
                // store.dispatch('genericError', 'Apologies, something appears to have gone wrong.', 10000);
            });
        },
        genericError:({commit}, message, time = 6000) => {
            if(message == null || message == ''){
                message = store.getters.getAppTextLanguage.account.error[store.getters.getLanguage];
            }

            Vue.toasted.show(message, {
                duration: time,
                position: 'top-center',
                type: "error",
                action: {
                    text: store.getters.getAppTextLanguage.introform.close[store.getters.getLanguage],
                    onClick : (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            });
        }
    },
    plugins: [
        vuejsStorage({ namespace: 'ye-interactive-videos' }) //call vuejsStorage with options will return a plugin
    ]
});

var hashCode = function(stringValue) {
    var hash = 0, i, chr;
    if (stringValue.length === 0) return hash;
    for (i = 0; i < stringValue.length; i++) {
        chr   = stringValue.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};



// WEBPACK FOOTER //
// ./src/plugins/store.js